import { Injectable } from '@angular/core';
import { BaseProvider } from './base';
import { API } from './api';
import { BrainProvider } from './brain';
import { ClassProvider } from './class';
import { DatasetProvider } from './dataset';
import { ProjectProvider } from './project';
import { CanvasProvider } from './workspace/canvas';
import { AuthProvider } from './auth';
import { UserProvider } from './user';
import { OrganizationProvider } from './organization';
import { JobProvider } from './job';
import { LocalStorageProvider } from './local-storage';
import { AssetProvider } from './asset';
import { OnPremiseProvider } from './on-premise';
import { WhiteLabelProvider } from './white-label';

/**
 * This provider allows the app to clear user info on logout
 */
@Injectable()
export class LogoutProvider extends BaseProvider {
    constructor(
        public api: API,
        public classProvider: ClassProvider,
        public brainProvider: BrainProvider,
        public datasetProvider: DatasetProvider,
        public projectProvider: ProjectProvider,
        public authProvider: AuthProvider,
        public canvasProvider: CanvasProvider,
        private localStorageProvider: LocalStorageProvider,
        public userProvider: UserProvider,
        public organizationProvider: OrganizationProvider,
        public jobProvider: JobProvider,
        public assetProvider: AssetProvider,
        public onPremiseProvider: OnPremiseProvider,
        public whiteLabelProvider: WhiteLabelProvider
    ) {
        super();
    }

    public async logout(): Promise<any> {
        try {
            // We need to unlock the current user's remaining locked assets, if any.
            this.assetProvider.unlockAllLockedAssets();
            await this.api.resetInfo();
            await this.localStorageProvider.remove('warningShownThisSession');
            await this.localStorageProvider.clear();

            // Then, we can clear out the rest of the providers.
            this.canvasProvider.resetInfo();
            this.authProvider.resetInfo();
            this.jobProvider.resetInfo();
            this.userProvider.resetInfo();
            this.organizationProvider.resetInfo();
            this.brainProvider.resetInfo();
            this.classProvider.resetInfo();
            this.datasetProvider.resetInfo();
            this.projectProvider.resetInfo();
            this.whiteLabelProvider.resetInfo();
        } catch (err) {
            throw err;
        }
    }
}



// WEBPACK FOOTER //
// ./src/providers/logout.ts